<template>
  <div class="container">
    <unit-title title="种植环节" />
    <div class="process-list">
      <van-steps direction="vertical" :active="selectedFarmWorkRecords.length" active-color="#20CAA0">
        <van-step v-for="( item , key ) in selectedFarmWorkRecords" :key="key">
          <template v-slot:inactive-icon>
            <div class="inactive">
              {{ key + 1 }}
            </div>
          </template>
          <div class="step-item">
            <template v-if="item.notChange">
              <div class="name">
                {{ item.name }}
              </div>
              <div class="bottom-content">
                <div class="time">
                  {{ formatTime(item.startDate, 'YYYY-MM-DD') }}
                </div>
              </div>
            </template>
            <template v-else>
              <div class="name">
                {{ item.farmWork }}
              </div>
              <div class="bottom-content">
                <div class="time">
                  {{ formatTime(item.beginTime, 'YYYY-MM-DD') }}
                </div>
                <div class="operator">
                  操作人：{{ item.operator }}
                </div>
              </div>
            </template>
          </div>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>
<script>
import { firstImgThumb } from '@/filter'
import { formatTime } from '@/utils/convert/convertTime'
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
export default {
  name: 'FarmWorkRecordSteps',
  filters: {
    firstImgThumb
  },
  components: { UnitTitle },
  props: {
    farmWorkRecords: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    selectedFarmWorkRecords() {
      return this.farmWorkRecords.filter(item => item.selected || item.notChange)
    }
  },
  methods: {
    formatTime
  }
}
</script>
<style lang="less" scoped>
.inactive{
  background-color: #20CAA0;
  color: #fff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
}
.container {
 .step-item{
   background-color: #F8F8F8;
   border-radius: 4px;
   padding: 14px 10px;
   width: 86%;
   box-shadow: 0 0 10px 0 #ccc;
   .name {
     font-size: 16px;
     font-weight: bold;
   }
   .bottom-content {
     display: flex;
     justify-content: space-between;
     align-items: flex-end;
     .time {
       padding: 1px 4px;
       background-image: linear-gradient(to right, #23bf7f, #51dc86);
       font-size: 14px;
       color: #fff;
       border-radius: 4px;
       margin-top: 10px;
     }
     .operator {
       font-size: 12px;
     }
   }

 }
}
</style>
